export default __webpack_public_path__ + "empty-job-failed-md.de6ea5f5.svg";